import { includes, range, remove, find } from 'lodash'
import { call, put } from 'redux-saga/effects'
import { authorization } from '../Module/Auth/Auth'
import { push } from 'react-router-redux'

import { PATHS } from '../Config/Routing/paths'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'
import { pushApiError } from 'Reducers/Errors/actions'

const genericErrorCodes = remove(range(400, 512), n => n !== 404 && n !== 403)

export function* afterCallApiInParallel(response) {
  yield put(decBlockCounter())

  const notAuthenticated = find(response, ({ status }) => status === 401)
  const notFound = find(response, ({ status }) => status === 404)
  const notAuthorised = find(response, ({ status }) => status === 403)

  if (notFound) {
    yield put(push(PATHS.dashboard.dashboard + PATHS.dashboard.notFound))
  }
  if (notAuthorised) {
    yield put(push(PATHS.dashboard.dashboard + PATHS.dashboard.notAuthorised))
  }
  if (notAuthenticated) {
    authorization.logout()
    yield put(push(PATHS.main.login))
    throw new Error('Not authenticated')
  }
}

function* executeCallApi(runsInForegroud, ...args) {
  if (runsInForegroud) {
    yield put(incUIBlockCounter())
  }
  try {
    const response = yield call(...args)
    const cloned = yield response.clone()
    const responseJson = yield cloned.json()

    const { status } = response

    if (includes(genericErrorCodes, status)) {
      yield put(pushApiError(responseJson.message))
    }

    if (runsInForegroud) {
      yield put(decBlockCounter())
    }

    if (status === 404) {
      yield put(push(PATHS.dashboard.dashboard + PATHS.dashboard.notFound))
    }
    if (status === 403) {
      yield put(push(PATHS.dashboard.dashboard + PATHS.dashboard.notAuthorised))
    }
    if (status === 401) {
      authorization.logout()
      yield put(push(PATHS.main.login))
    }

    return response
  } catch (error) {
    yield put(pushApiError(new Error(error)))
  }
}

export function* callApiInBackground(...args) {
  return yield executeCallApi(false, ...args)
}

export function* callApi(...args) {
  return yield executeCallApi(true, ...args)
}
